import ApiStore from "../ApiStore";
import { makeAutoObservable } from "mobx";

export default class WorkOrdersStore {
    private _api: ApiStore;
    isLoading: boolean = false;
    constructor(api: ApiStore) {
        makeAutoObservable(this);
        this._api = api
    }
    getWorkOrdersForResident = async (assetId:number, userId:number, page:number, pageSize:number) => {
        const response = await this._api.FormsApiClient.getWorkOrdersForResident(assetId, userId, page, pageSize);
        return response || [];
    };
    getDetailsForWorkOrder = async (id:string, userId : string) => {
        const response = await this._api.FormsApiClient.getDetailsForWorkOrder(id, userId);
        return response || [];
    };
    deleteWorkOrder = async (workOrderId:number) => {
        const response = await this._api.FormsApiClient.deleteWorkOrder(workOrderId);
        return response || [];
    };
    createWorkOrder = async (request:Object) => {
        const response = await this._api.FormsApiClient.createWorkOrder(request);
        return response || [];
    };
    addAttachment = async (request:Object) => {
        const response = await this._api.FormsApiClient.addAttachment(request);
        return response || [];
    };
    addNote = async (request:Object) => {
        const response = await this._api.FormsApiClient.addNote(request);
        return response || [];
    };
    cancelWorkOrder = async (id:number): Promise<{ ok: boolean; notified: boolean; errorMessage?: string }> => {
        const response: any = await this._api.FormsApiClient.cancelWorkOrder(id);
        if (!response) {
            return { ok: false, notified: true };
        }
        if (response.status !== 200) {
            return { ok: false, notified: false };
        }
        const errorMessage = this.extractCorrigoError(response.data);
        return errorMessage ? { ok: false, notified: false, errorMessage } : { ok: true, notified: false };
    };

    private extractCorrigoError = (data: any): string | undefined => {
        let body = data;
        if (typeof body === "string") {
            try {
                body = JSON.parse(body);
            } catch {
                return undefined;
            }
        }
        if (!body || typeof body !== "object") return undefined;
        const message = body.ErrorMessage ?? body.errorMessage;
        return typeof message === "string" && message.trim() ? message.trim() : undefined;
    };
}